import { render, staticRenderFns } from "./GenericRedirectView.vue?vue&type=template&id=20850335&scoped=true&"
import script from "./GenericRedirectView.vue?vue&type=script&lang=js&"
export * from "./GenericRedirectView.vue?vue&type=script&lang=js&"
import style0 from "./GenericRedirectView.vue?vue&type=style&index=0&id=20850335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20850335",
  null
  
)

export default component.exports